const MODULE_NAME = "MANAGE_LICENSES_";
const FETCH_LICENSES_STARTED = MODULE_NAME + 'FETCH_STARTED';
const FETCH_LICENSES_COMPLETED = MODULE_NAME + 'FETCH_COMPLETED';
const FETCH_LICENSE_STARTED = MODULE_NAME + 'FETCH_SHOW_STARTED';
const FETCH_LICENSE_COMPLETED = MODULE_NAME + 'FETCH_SHOW_COMPLETED';
const CREATE_LICENSE_STARTED = MODULE_NAME + 'CREATE_STARTED';
const CREATE_LICENSE_COMPLETED = MODULE_NAME + 'CREATE_COMPLETED';
const CREATE_LICENSE_ERROR = MODULE_NAME + 'CREATE_ERROR';
const UPDATE_LICENSE_STARTED = MODULE_NAME + 'UPDATE_LICENSE_STARTED';
const UPDATE_LICENSE_COMPLETED = MODULE_NAME + 'UPDATE_LICENSE_COMPLETED';
const DELETE_LICENSE_COMPLETED = MODULE_NAME + 'DELETE_LICENSE_COMPLETED';
const DELETE_LICENSE_STARTED = MODULE_NAME + 'DELETE_LICENSE_STARTED';

export {
  FETCH_LICENSES_STARTED,
  FETCH_LICENSES_COMPLETED,
  FETCH_LICENSE_STARTED,
  FETCH_LICENSE_COMPLETED,
  CREATE_LICENSE_STARTED,
  CREATE_LICENSE_COMPLETED,
  CREATE_LICENSE_ERROR,
  UPDATE_LICENSE_STARTED,
  UPDATE_LICENSE_COMPLETED,
  DELETE_LICENSE_STARTED,
  DELETE_LICENSE_COMPLETED
};
